module.exports = __webpack_public_path__ + "static/media/amod-img.8858a826.png";